import Typography from '@material-ui/core/Typography';
import BubbleChartIcon from '@material-ui/icons/BubbleChart';
import PropTypes from 'prop-types';
import React from 'react';
import withGS from '../../core/withGShoc';

class SchemeLink extends React.Component {

    render() {

        const { data, defaultLang, id } = this.props;

        return (
            <Typography data-test="scheme-link"
                variant="caption"
                style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap'
                }}>
                <BubbleChartIcon fontSize="small" style={{ verticalAlign: 'bottom', marginInlineEnd: 4 }} />
                {data.title && data.title[defaultLang] ? data.title[defaultLang] : id}
            </Typography>
        );
    }
}

SchemeLink.propTypes = {
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired
};

export default withGS(SchemeLink, ["ALL"], ["id", "title", "hasEntitlement"], { predicates: ["http://purl.org/dc/terms/title"] });